// Flags used by the Tandem loader to keep track of individual fragments.
// The flags array is also sent to the BVH worker, so certain flags are defined by LMV.
// Tandem's flags are appended dynamically.

// Defined by LMV, used for BVH construction.
// TODO: Remove fallback case where LMV flags are not defined, once we actually use LMV.
const FragInfoFlags = Autodesk.Viewing.Private.FragInfoFlags ?? {};
const numFragInfoFlags = Object.keys(FragInfoFlags).length;

const transparentFlagName = 'IS_TRANSPARENT';
const TandemFlagNames = ['IS_LOADED', transparentFlagName, 'IS_ROOM'];
const numTandemFlags = TandemFlagNames.length;

// Assertions
if (numFragInfoFlags && !FragInfoFlags.hasOwnProperty(transparentFlagName)) {
  throw new Error('LMV flags are missing the transparent flag');
}

// -1 because the transparent bit is the same in both.
if (numFragInfoFlags && numFragInfoFlags + numTandemFlags - 1 > 8) {
  throw new Error('Too many fragment flags');
}

// Construct flag object.
// Copy LMV flags first. This assumes that they use increasing values, starting at 0;
const tandemFlags = { ...FragInfoFlags };

// Append Tandem flags.
let curFlag = 1 << numFragInfoFlags;
for (const flag of TandemFlagNames) {
  if (numFragInfoFlags && flag === transparentFlagName) {
    // Already copied from LMV.
    continue;
  }

  tandemFlags[flag] = curFlag;
  curFlag = curFlag << 1;
}

// console.log(tandemFlags);

export const FragmentFlags = Object.freeze(tandemFlags);